import React, { useEffect, useMemo } from 'react';
import { useShortUrl } from '@app/api';

export const RedirectFromDeprecated = () => {
  const shortUrl = useShortUrl();
  const url = useMemo(() => {
    if (typeof window === 'undefined') {
      return shortUrl;
    }

    const { pathname, search } = window.location;
    return `${shortUrl}${pathname}${search}`;
  }, [shortUrl]);

  useEffect(() => {
    if (!url || !shortUrl) {
      return;
    }
    window.location.href = url;
  }, [url, shortUrl]);

  if (!shortUrl) {
    return null;
  }

  return null;
};
